export default __webpack_public_path__ + "images/models/2224023bf330344fc7e2400d0ceb7825.usdz";